export const saveButtonProps = { color: 'blue', lightSwatch: 600 };
